import { Plugin } from 'prosemirror-state'

import { DEFAULT_CONTD_DISPLAY_TEXT } from '#util'

import { isCharContdsEnabled } from '../configData'

import {
  characterContdsPluginKey,
  getContdInventory,
  getDecorations,
  Inventory,
} from './helpers'

// the most convoluted way to supply a plain string yet devised
type PluginParams = {
  script: {
    scriptFormat: {
      definition: { moresContds?: { contdDisplayText?: string } }
    }
  }
}

export const characterContdsPlugin = ({
  script: {
    scriptFormat: { definition },
  },
}: PluginParams) => {
  const displayText =
    definition.moresContds?.contdDisplayText ?? DEFAULT_CONTD_DISPLAY_TEXT

  return new Plugin<Inventory>({
    state: {
      init(_, state) {
        if (isCharContdsEnabled(state)) {
          return getContdInventory(state)
        }
        return []
      },
      apply(tr, pluginState, oldState, newState) {
        const wasEnabled = isCharContdsEnabled(oldState)
        const isEnabled = isCharContdsEnabled(newState)
        const justEnabled = isEnabled && !wasEnabled

        if (!isEnabled) return []

        if (justEnabled || tr.docChanged) {
          return getContdInventory(newState)
        }

        return pluginState
      },
    },
    key: characterContdsPluginKey,
    props: {
      decorations(state) {
        return getDecorations({ state, displayText })
      },
    },
  })
}
